"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @category High Order Guard
 * @return a `Guard` that checks that the value is of the type of the guard passed or null
 * @example
 * ```typescript
 *   const isNullableAge = NullableOf(isNumber);
 *   const isPersonTuple: Guard<[string, number | null]> = TupleOf([isString, isNullableAge]);
 * ```
 */
const NullableOf = (guard) => {
    return (v) => v === null || guard(v);
};
exports.default = NullableOf;
